import {
    REQUEST_UPLOAD,
    UPLOAD_SUCCEDED,
    UPLOAD_FAILED
} from './types';

export const requestUpload = (payload) => ({
    type: REQUEST_UPLOAD,
    payload,
});

export const uploadSucceeded = (payload) => ({
    type: UPLOAD_SUCCEDED,
    payload,
});

export const uploadFailed  = (payload) => ({
    type: UPLOAD_FAILED,
    payload,
});



// WEBPACK FOOTER //
// ./src/SHARED/actions/image.actions.js